/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { OutreachStatus } from './OutreachStatus';
import {
    OutreachStatusFromJSON,
    OutreachStatusFromJSONTyped,
    OutreachStatusToJSON,
    OutreachStatusToJSONTyped,
} from './OutreachStatus';
import type { OutreachPurpose } from './OutreachPurpose';
import {
    OutreachPurposeFromJSON,
    OutreachPurposeFromJSONTyped,
    OutreachPurposeToJSON,
    OutreachPurposeToJSONTyped,
} from './OutreachPurpose';
import type { OutreachDeliveryStatus } from './OutreachDeliveryStatus';
import {
    OutreachDeliveryStatusFromJSON,
    OutreachDeliveryStatusFromJSONTyped,
    OutreachDeliveryStatusToJSON,
    OutreachDeliveryStatusToJSONTyped,
} from './OutreachDeliveryStatus';
import type { OutreachChannel } from './OutreachChannel';
import {
    OutreachChannelFromJSON,
    OutreachChannelFromJSONTyped,
    OutreachChannelToJSON,
    OutreachChannelToJSONTyped,
} from './OutreachChannel';

/**
 * 
 * @export
 * @interface OutreachAttempt
 */
export interface OutreachAttempt {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    participant_id: string | null;
    /**
     * 
     */
    request_id: string | null;
    /**
     * 
     */
    purpose: OutreachPurpose;
    /**
     * 
     */
    channel: OutreachChannel;
    /**
     * 
     */
    status: OutreachStatus;
    /**
     * 
     */
    delivery_status: OutreachDeliveryStatus | null;
    /**
     * 
     */
    last_error_code: string | null;
    /**
     * 
     */
    created_at: Date;
    /**
     * 
     */
    completed_at: Date | null;
    /**
     * 
     */
    link_expires_at: Date | null;
    /**
     * 
     */
    first_opened_at: Date | null;
}



/**
 * Check if a given object implements the OutreachAttempt interface.
 */
export function instanceOfOutreachAttempt(value: object): value is OutreachAttempt {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('participant_id' in value) || value['participant_id'] === undefined) return false;
    if (!('request_id' in value) || value['request_id'] === undefined) return false;
    if (!('purpose' in value) || value['purpose'] === undefined) return false;
    if (!('channel' in value) || value['channel'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('delivery_status' in value) || value['delivery_status'] === undefined) return false;
    if (!('last_error_code' in value) || value['last_error_code'] === undefined) return false;
    if (!('created_at' in value) || value['created_at'] === undefined) return false;
    if (!('completed_at' in value) || value['completed_at'] === undefined) return false;
    if (!('link_expires_at' in value) || value['link_expires_at'] === undefined) return false;
    if (!('first_opened_at' in value) || value['first_opened_at'] === undefined) return false;
    return true;
}

export function OutreachAttemptFromJSON(json: any): OutreachAttempt {
    return OutreachAttemptFromJSONTyped(json, false);
}

export function OutreachAttemptFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutreachAttempt {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'participant_id': json['participant_id'],
        'request_id': json['request_id'],
        'purpose': OutreachPurposeFromJSON(json['purpose']),
        'channel': OutreachChannelFromJSON(json['channel']),
        'status': OutreachStatusFromJSON(json['status']),
        'delivery_status': OutreachDeliveryStatusFromJSON(json['delivery_status']),
        'last_error_code': json['last_error_code'],
        'created_at': (json['created_at'] == null ? json['created_at'] : parseDateTime(json['created_at'])),
        'completed_at': (json['completed_at'] == null ? null : parseDateTime(json['completed_at'])),
        'link_expires_at': (json['link_expires_at'] == null ? null : parseDateTime(json['link_expires_at'])),
        'first_opened_at': (json['first_opened_at'] == null ? null : parseDateTime(json['first_opened_at'])),
    };
}

export function OutreachAttemptToJSON(json: any): OutreachAttempt {
    return OutreachAttemptToJSONTyped(json, false);
}

export function OutreachAttemptToJSONTyped(value?: OutreachAttempt | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'participant_id': value['participant_id'],
        'request_id': value['request_id'],
        'purpose': OutreachPurposeToJSON(value['purpose']),
        'channel': OutreachChannelToJSON(value['channel']),
        'status': OutreachStatusToJSON(value['status']),
        'delivery_status': OutreachDeliveryStatusToJSON(value['delivery_status']),
        'last_error_code': value['last_error_code'],
        'created_at': value['created_at'] == null ? value['created_at'] : serializeDateTime(value['created_at']),
        'completed_at': value['completed_at'] == null ? value['completed_at'] : serializeDateTime(value['completed_at']),
        'link_expires_at': value['link_expires_at'] == null ? value['link_expires_at'] : serializeDateTime(value['link_expires_at']),
        'first_opened_at': value['first_opened_at'] == null ? value['first_opened_at'] : serializeDateTime(value['first_opened_at']),
    };
}

